<ion-header>
  <ng-content select="itl-modal-page-header"></ng-content>
</ion-header>
<!-- <ion-content> -->
<div class="content"><ng-content> </ng-content></div>
<!-- </ion-content> -->
